import { criarRepositorio } from './createRepository';

export const repositorioFornecedor = criarRepositorio('fornecedor');
export const repositorioCliente = criarRepositorio('cliente');
export const repositorioContaBancaria = criarRepositorio('conta_bancaria');
export const repositorioCategoriaMestra = criarRepositorio('categoria_mestra');
export const repositorioCategoriaFinanceira = criarRepositorio('categoria_financeira');
export const repositorioCentroCusto = criarRepositorio('centro_custo');
export const repositorioFormaPagamento = criarRepositorio('forma_pagamento');
export const repositorioContaPagar = criarRepositorio('conta_pagar');
export const repositorioContaReceber = criarRepositorio('conta_receber');
export const repositorioPagamento = criarRepositorio('pagamento');
export const repositorioNotaFiscal = criarRepositorio('nota_fiscal');
